// src/components/report/PlanningCTA.js
import React from 'react';

const PlanningCTA = () => (
    <div className="space-y-6">
        <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <h3 className="text-lg font-bold text-[#234363] mb-3">خطط لأهدافك المستقبلية</h3>
            <p className="text-gray-600 mb-4">
                لحساب المبلغ المطلوب للوصول لأهدافك وتخطيط رحلة التحويش الخاصة بك
            </p>
            <a 
                href="https://wealth.taiseer.co/savings" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#234363] hover:bg-[#1a3048] text-white font-medium px-8 py-3 rounded-lg transition-colors duration-200"
            >
                احسب هدفك الآن
            </a>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <h3 className="text-lg font-bold text-[#234363] mb-3">رأيك يهمنا</h3>
            <p className="text-gray-600 mb-4">
                نود أن نسمع رأيك في تجربتك مع تيسير. شاركنا ملاحظاتك واقتراحاتك لنقدم لك خدمة أفضل
            </p>
            <a 
                href="https://forms.gle/HHny1GqpVVkXFUuB9" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#234363] hover:bg-[#1a3048] text-white font-medium px-8 py-3 rounded-lg transition-colors duration-200"
            >
                شارك برأيك
            </a>
        </div>
    </div>
);

export default PlanningCTA;

/* // Alternative button-only version if preferred:
const PlanningCTAButton = () => (
    <div className="text-center">
        <a 
            href="https://wealth.taiseer.co/savings" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-[#234363] hover:bg-[#1a3048] text-white font-medium px-8 py-4 rounded-xl shadow-lg transition-colors duration-200 w-full md:w-auto"
        >
            احسب واخطط لأهدافك المستقبلية
        </a>
    </div>
);

// Export both versions
export { PlanningCTA as default, PlanningCTAButton }; */